if (!customElements.get('campaign-artwork')) {
  customElements.define('campaign-artwork', class extends HTMLElement {
    connectedCallback() {
      if (this.played || !this.hasAttribute('animate')) return;
      this.media = this.querySelector('picture');
      this.image = this.querySelector('img');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.media?.animate || !window.IntersectionObserver || this.motion.matches) return;

      this.onMotionChange = () => {
        if (this.motion.matches) {
          this.played = true;
          this.stop();
        }
      };
      this.onLoad = () => this.enter();
      this.onVisibility = () => {
        if (!document.hidden && !this.played) {
          this.observer.unobserve(this);
          this.observer.observe(this);
        }
      };
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = Boolean(entry?.isIntersecting);
        if (this.inView) this.enter();
      }, { threshold: 0.15 });
      this.motion.addEventListener('change', this.onMotionChange);
      this.addEventListener('load', this.onLoad, true);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer.observe(this);
    }

    enter() {
      if (this.played || !this.inView || document.hidden || this.motion.matches) return;
      if (!this.image?.complete || !this.image.naturalWidth) return;
      this.played = true;
      this.observer.disconnect();
      const easing = getComputedStyle(this).getPropertyValue('--ease-out-quad').trim()
        || 'cubic-bezier(0.32, 0.72, 0, 1)';
      // Animate the picture, preserving the artwork wrapper's position transform.
      this.animation = this.media.animate([
        { opacity: 0, transform: 'translateY(12px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ], { duration: 450, easing });
    }

    stop() {
      this.observer?.disconnect();
      this.animation?.cancel();
      this.motion?.removeEventListener('change', this.onMotionChange);
      this.removeEventListener('load', this.onLoad, true);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      this.stop();
    }
  });
}
